module.exports = __webpack_public_path__ + "img/kr-product-final-card1-img4.c879d01.png";